import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/site";
import { EASE } from "@/components/Reveal";

const links = [
  { href: "#como-funciona", label: "Como funciona", id: "nav-link-como-funciona" },
  { href: "#para-quem", label: "Para quem é", id: "nav-link-para-quem" },
  { href: "#investimento", label: "Investimento", id: "nav-link-investimento" },
  { href: "#faq", label: "FAQ", id: "nav-link-faq" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <motion.header
      initial={{ y: -72, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: EASE, delay: 0.15 }}
      className="fixed top-0 inset-x-0 z-50 border-b border-ink/10 bg-paper/70 backdrop-blur-xl"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <a href="#top" data-testid="brand-link" className="flex items-center">
          <img
            src="/logo-ocean-star.png"
            alt="Ocean Star — Assessoria Eleitoral"
            className="h-11 md:h-12 w-auto"
          />
        </a>
        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink/55 transition-colors duration-300 hover:text-ink"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            data-testid="nav-whatsapp-cta"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group hidden md:inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 font-mono text-[11px] font-bold uppercase tracking-[0.1em] text-paper transition-colors duration-300 hover:bg-brass hover:text-ink"
          >
            Falar no WhatsApp
            <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-full border border-ink/15 text-ink transition-colors duration-300 hover:border-ink/40"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: EASE }}
            className="lg:hidden overflow-hidden border-t border-ink/10 bg-paper/95 backdrop-blur-xl"
            data-testid="mobile-menu-panel"
          >
            <div className="px-6 py-7 flex flex-col gap-6">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`mobile-${l.id}`}
                  onClick={() => setOpen(false)}
                  className="font-mono text-[12px] uppercase tracking-[0.18em] text-ink/70 transition-colors duration-300 hover:text-ink"
                >
                  {l.label}
                </a>
              ))}
              <a
                data-testid="mobile-whatsapp-cta"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-ink px-6 py-3.5 font-mono text-[11.5px] font-bold uppercase tracking-[0.1em] text-paper transition-colors duration-300 hover:bg-brass hover:text-ink"
              >
                Falar no WhatsApp
                <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
